module.exports = __webpack_public_path__ + "static/media/congress-house-floor-diagram.077c0ea1.svg";